"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportTypeEnum = void 0;
var ImportTypeEnum;
(function (ImportTypeEnum) {
    ImportTypeEnum["Degiro"] = "degiro";
    ImportTypeEnum["Etoro"] = "etoro";
    ImportTypeEnum["XtbOld"] = "xtbOld";
    ImportTypeEnum["XtbNew"] = "xtbNew";
    ImportTypeEnum["Trading212"] = "trading212";
    ImportTypeEnum["InteractiveBrokers"] = "interactiveBrokers";
    ImportTypeEnum["Monery"] = "monery";
    ImportTypeEnum["Coinbase"] = "coinbase";
    ImportTypeEnum["Anycoin"] = "anycoin";
    ImportTypeEnum["Portu"] = "portu";
    ImportTypeEnum["Binance"] = "binance";
    ImportTypeEnum["Fio"] = "fio";
    ImportTypeEnum["Snowball"] = "snowball";
    ImportTypeEnum["YahooFinance"] = "yahooFinance";
    ImportTypeEnum["Coinmate"] = "coinmate";
    ImportTypeEnum["Patria"] = "patria";
    ImportTypeEnum["Lynx"] = "lynx";
    ImportTypeEnum["CoinbasePro"] = "coinbasePro";
    ImportTypeEnum["Revolut"] = "revolut";
})(ImportTypeEnum = exports.ImportTypeEnum || (exports.ImportTypeEnum = {}));
//# sourceMappingURL=import-type-enum.js.map